module.exports = __webpack_public_path__ + "img/2537f6c.png";